import { render, staticRenderFns } from "./estimate-table.vue?vue&type=template&id=6bf4c5fa&scoped=true"
import script from "./estimate-table.vue?vue&type=script&lang=js"
export * from "./estimate-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf4c5fa",
  null
  
)

export default component.exports